import { Controller } from '@hotwired/stimulus'

// Reveals the panel belonging to the checked option in a ux-admin-single-select
// group, and disables the controls in the panels it hides.
//
// Disabling is the load-bearing half. A hidden input still submits, and a hidden
// `required` field blocks the form with a validation error pointing at nothing
// the user can see. A disabled control does neither.
//
// A panel names its option with `data-option-value`. Options that reveal nothing
// need no panel.
export default class extends Controller {
  static targets = ['option', 'panel']

  connect() {
    this.reveal()
  }

  reveal() {
    const selected = this.optionTargets.find(option => option.checked)?.value

    this.panelTargets.forEach(panel => {
      const shown = panel.dataset.optionValue === selected
      panel.hidden = !shown
      this.#controlsIn(panel).forEach(control => {
        // Revealing restores a control to how it was rendered, so one disabled
        // for its own reasons stays that way.
        control.disabled = !shown || control.dataset.disabledOriginal === 'true'
      })
    })
  }

  #controlsIn(panel) {
    return [panel, ...panel.querySelectorAll('input, select, textarea, button')]
      .filter(node => 'disabled' in node)
  }
}
